module.exports = __webpack_public_path__ + "static/404-error-a5414252ec2f46d8af55254005a90a26.png";